<template>
  <animated-mask class="contact-view">
    <mdb-container class="contact-container">
      <mdb-row>
        <mdb-col col="12" class="d-flex justify-content-center contact-logo">
          <CompanyLogo 
            companyName="FJData AB" 
            companyBranch="IT Consulting"
            companySkillset="Software Infrastructure Web" />
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col sm="12" md="12" class="white-text">
          <form class="contact-form white-text">
            <mdb-container>
              
              <mdb-row>
                <mdb-col sm="12" md="6">
                  <mdb-input id="contact-name" name="name" label="What should I call you?" icon="user" group type="text" validate error="wrong" success="right" v-model="contact.name" />
                  <mdb-input id="contact-email" name="email" label="Your email address" icon="envelope" group type="text" validate error="wrong" success="right" v-model="contact.email" />
                  <mdb-input id="contact-phone" name="phone" label="Your phone number" icon="phone" group type="text" validate error="wrong" success="right" v-model="contact.phone" />
                </mdb-col>
                
                <mdb-col sm="12" md="6">
                  <mdb-input id="contact-country" name="country" label="Where in the world are you?" icon="globe" group type="text" validate error="wrong" success="right" v-model="contact.country" />
                  <mdb-textarea id="contact-address" name="address" rows="2" label="Visitors' address (optional)" icon="home" group type="text" validate error="wrong" success="right" v-model="contact.address" />
                </mdb-col>
              </mdb-row>
              
              <mdb-row>
                <mdb-col sm="12" md="12">
                  <mdb-input id="contact-subject" name="subject" label="Subject" icon="tag" group type="text" validate error="wrong" success="right" v-model="contact.subject" />
                </mdb-col>
                <mdb-col sm="12" md="12">
                  <mdb-textarea id="contact-message" name="message" rows="6" label="Message" icon="pen" group type="text" validate error="wrong" success="right" v-model="contact.message" />
                </mdb-col>
              </mdb-row>
              
            </mdb-container>
          </form>
          
          <mdb-container>
            <mdb-row>
              <mdb-col col="12" sm="12" md="8" lg="9" xl="9" class="d-flex justify-content-end">
                <mdb-container class="consent-container">
                  <mdb-row>
                    <mdb-col col="2" sm="2" md="2" lg="1"  class="d-flex justify-content-end">
                      <mdb-input class="consent-checkbox" type="checkbox" v-model="consent.termsAndPrivacy" /> 
                    </mdb-col>
                    <mdb-col col="10" sm="10" md="10" lg="11"  class="d-flex justify-content-start">
                      <label class="consent-label">I confirm that I have read and agree to FJData AB <!-- <a href="#">terms</a> and --> <a href="#" @click="$event.preventDefault(); showPrivacyModal = true;">privacy policy</a>.</label>
                    </mdb-col>
                  </mdb-row>
                </mdb-container>
              </mdb-col>
              <mdb-col sm="12" md="4" lg="3" xl="3" class="d-flex justify-content-end">
                <mdb-btn color="mdb-color" class="contact-send-button btn-rounded" v-on:click="sendMail" :enabled="!emailState.isSending">
                  <span v-if="emailState.isSending">
                    Sending <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </span>
                  <span v-else-if="emailState.isSent">
                    Sent <mdb-icon icon="check" class="ml-1" />
                  </span>
                  <span v-else-if="emailState.isError">
                    Error <mdb-icon  icon="exclamation-triangle" />
                  </span>
                  <span v-else>
                    Send <mdb-icon far icon="paper-plane" class="ml-1" />
                  </span>
                </mdb-btn>
              </mdb-col>
            </mdb-row>
            
          </mdb-container>
        </mdb-col>
      </mdb-row>
      
      <privacy-modal 
        :showModal="showPrivacyModal"
        @close-modal="showPrivacyModal = false" />
    </mdb-container>
  </animated-mask>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbInput,
  mdbTextarea,
  mdbBtn,
  mdbIcon
} from 'mdbvue'
import AnimatedMask from '@/components/AnimatedMask.vue'
import CompanyLogo from '@/components/CompanyLogo.vue'
import PrivacyModal from '@/components/PrivacyModal.vue'
import axios from 'axios'

export default {
  name: 'ContactForm',
  props: {
    
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbIcon,
    AnimatedMask,
    CompanyLogo,
    PrivacyModal
  },
  data: function() {
    return {
      contact: {
        name: '',
        email: '',
        phone: '',
        country: 'Sweden',
        address: '',
        subject: '',
        message: '',
        consentToPolicies: false
      },
      emailState: {
        isSending: false,
        isSent: false,
        isError: false
      },
      showPrivacyModal: false,
      consent: { 
        termsAndPrivacy: false
      }
    }
  },
  methods: {
    sendMail: function() {  
      if (!this.consent.termsAndPrivacy)
      {
        alert("You must tick the box confirming that you have read and agree to the terms and privacy policy.");
        return;
      }
      
      // Alter icon
      this.emailState.isSending = true;

      axios.post(process.env.VUE_APP_API_BASE_URL, {
        name: this.contact.name,
        email: this.contact.email,
        phone: this.contact.phone,
        country: this.contact.country,
        address: this.contact.address,
        subject: this.contact.subject,
        message: this.contact.message
      })
      .then((response) => {
        if (response.status == 200)
        {
//           alert("Email sent successfully!");
          console.log(response);
          this.contact.name = '';
          this.contact.email = '';
          this.contact.phone = '';
          this.contact.country = 'Sweden';
          this.contact.address = '';
          this.contact.subject = '';
          this.contact.message = '';
          this.emailState.isSending = false;
          this.emailState.isSent = true;
          this.emailState.isError = false;
        }
        else 
        {
          alert("Email was not sent, problem encountered. \nUse email instead, sorry for the inconvenience.");
          this.emailState.isSending = false;
          this.emailState.isSent = false;
          this.emailState.isError = true;
        }
      })
      .catch((error) => {
        this.emailState.isSending = false;
        this.emailState.isSent = false;
        this.emailState.isError = true;
        
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
//           console.log(error.response.data);
//           console.log(error.response.status);
//           console.log(error.response.headers);
          alert("Email was not sent, problem encountered. \nUse email instead, sorry for the inconvenience. (error: "+status+")");
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
//           console.log(error.request);
          alert("Email was not sent, problem encountered. \nUse email instead, sorry for the inconvenience. (error: no response)");
        } else {
          // Something happened in setting up the request that triggered an Error
//           console.log('Error', error.message);
          alert("Email was not sent, problem encountered. \nUse email instead, sorry for the inconvenience. (error: in setup)");
        }
//         console.log(error.config);
      });
    }
  }
}
</script>

<style scoped>
.contact-view {
  height: 100%;
  min-height: 1080px;
}

@media (max-width: 768px) {
  .contact-view {
    min-height: 1330px;
  }
}

.contact-container {
  padding-top: 75px;
  padding-bottom: 75px;
}

.contact-logo {
  padding-bottom: 50px;
}

.contact-form {
  text-align: left;
  color: #DEDEDE;
}

.contact-form input[type=text]:focus:not([readonly]) + label {
  color: #DEDEDE;
}

.contact-form input[type=password]:focus:not([readonly]) + label {
  color: #DEDEDE;
}

.consent-container {
  text-align: center;
  color: #DEDEDE !important;
}

.consent-checkbox {
    position: relative;
    left: 20px;
    top: 0px;
}

.consent-label {
  text-align: left;
}

@media (max-width: 768px) {
 
  .consent-container {
    text-align: center;
  }
  
  .consent-checkbox {
    position: relative;
    left: 20px;
    top: 0px;
  }
  
  .consent-label {
    
  }
}

@media (min-width: 992px) {
  .consent-container {
    text-align: right;
    padding-left: 50px;
  }
  
  .consent-checkbox {
    position: relative;
    left: 20px;
    top: 5px;
  }
  
  .consent-label {
    padding-left: 0px;
    padding-top: 17px;
  }
}

@media (min-width: 1200px) {
  .consent-container {
    padding-left: 200px;
  }
}

a,a:visited,a:active {
  text-decoration: none;
  color: grey;
}
a:hover {
  text-decoration: none;
  color: white;
}

.contact-send-button {

}

/* Fix for missing funcitonality, in wait of patches. */
.btn-rounded {
  border-radius: 10em;
}
</style>

<style>
.form-control  {
  color: #DEDEDE !important;
}
</style>